/* globals updateEventBind, addQueryParam */
(function () {
	'use strict';

	angular.module('app.dashboard')
		.controller('inventoryActionsStatusCtrl', inventoryActionsStatusCtrl);

	function inventoryActionsStatusCtrl($scope, config, leanFilterService,
			dashboardFilterInitializationService, $timeout, $rootScope,
			inventoryActionsStatusService, pageTimingService,
			storeService) {
		$scope.ignoreFilters = ['responsibleNdx', 'taskCategory', 'taskStatus'];
		$scope.filterService = dashboardFilterInitializationService;
		$scope.leanFilterService = leanFilterService;
		$scope.isReadOnly = storeService.getState().reportSettings.readOnly;

		$scope.$parent.$parent.showViewReport = true;

		$scope.slideshowView = $rootScope.slideshowView;
		$scope.showToggle = true;
		$scope.toggleMode = toggleMode;

		$scope.chartTitles = {
			Count: 'Number of Actions',
			Savings: 'Value of Actions'
		};
		$scope.currentMode = 'Savings';
		$scope.otherMode = 'Count';
		if (config.mode === 'Count') {
			$scope.currentMode = 'Count';
			$scope.otherMode = 'Savings';
		}

		updateEventBind($scope, ['sideBarUpdate', 'adfFactoryChanged',
			'slideshowViewChanged', 'inventoryFilterChanged']);

		function toggleMode() {
			// swap mode
			var temp = $scope.currentMode;
			$scope.currentMode = $scope.otherMode;
			$scope.otherMode = temp;
			// save config
			var widget = $scope.$parent.model;
			widget.config.mode = $scope.currentMode;
			pendo.track('widgetChangeConfig', {
				widgetType: $scope.config.type,
				mode: $scope.currentMode
			});
			var columnDefinition = $scope.$parent.$parent.col;
			storeService.dispatch({
				type: storeService.actions.CONFIG_WIDGET_UPDATE_ONE,
				payload: {
					column: 'column' + columnDefinition.columnIndex,
					position: columnDefinition.widgets.indexOf(widget),
					widget: {
						name: widget.config.type,
						config: _.cloneDeep(widget.config)
					}
				},
				meta: {
					reportName: undefined,
					reportSettingsId: globalReportName
				}
			});
			loadData();
		}

		function getChart() {
			var columnDefinition = $scope.$parent.$parent.col;
			var curWidget = $scope.$parent.model;
			inventoryActionsStatusService.getInventoryActionsStatusData(
				$scope.leanFilterService, $scope.currentMode, $scope.ignoreFilters)
				.then(
					function (d) {
						$scope.chartData = d.data;
						$scope.currency = d.currency;
						angular.forEach($scope.chartData, function (dp) {
							dp['Fixed'] = dp.numFixed ? dp.numFixed : 0;
							dp['Unable to Fix'] = dp.numUnableToFix ? dp.numUnableToFix : 0;
							dp['Expired'] = dp.numExpired ? dp.numExpired : 0;
							dp['Open'] = dp.numOpen ? dp.numOpen : 0;
							dp['Total'] = dp['Fixed'] + dp['Unable to Fix'] + dp['Open'] + dp['Expired'];
						});
						$scope.empty = !$scope.chartData || !$scope.chartData.length;
						$scope.$broadcast('event:inventoryActionsStatusCtrl:getChart', null);
						if (!$scope.slideshowView) {
							pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
					},
					function (e) {
						$scope.empty = true;
						$scope.chartData = [];
						$scope.$broadcast('event:inventoryActionsStatusCtrl:getChart', null);
						if (!$scope.slideshowView) {
							pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
					}
				);
		}

		function loadData() {
			if (!dashboardFilterInitializationService.updating['initialLoad']) {
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				if (!$scope.slideshowView) {
					dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
				}
				getChart();
				var filterQueryParams = $scope.leanFilterService.getQueryParamsObject(true, true);
				filterQueryParams['drilldown'] = 1;
				filterQueryParams['factory'] = $scope.leanFilterService.getFactoryList();
				filterQueryParams['sort'] = 'potentialSavings';
				filterQueryParams['sortDesc'] = 1;
				filterQueryParams = _.omit(filterQueryParams, $scope.ignoreFilters);
				$scope.$parent.$parent.widget.drillDownUrl = addQueryParam(
					'/application/f/home.html#/supply-chain/inventory-actions/', null, filterQueryParams);
			} else {
				$timeout(loadData, 100);
			}
		}

		loadData();
	}
})();
